/* @flow */
import cx from 'classnames';
import * as React from 'react';

import TitleHeader from 'components/TitleHeader.jsx';

import './styles/BoxHeader.scss';

import type { Props as TitleHeaderProps } from 'components/TitleHeader.jsx'; // eslint-disable-line no-unused-vars

// prettier-ignore
export type Props = {
  dark?: bool,
  /* :: ...$Exact<TitleHeaderProps>, */
}

/**
 * ## Header area for use within a [Box](/internal/components/Box).
 *
 *
 * # Common Usage
 * ```example
 * <Box>
 *   <BoxHeader
 *     subtext="BoxHeader subtext"
 *     title="BoxHeader title"
 *   />
 *   <BoxBody>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </BoxBody>
 * </Box>
 * ```
 *
 * ```example
 * <Box>
 *   <BoxHeader
 *     action={<Button>Button</Button>}
 *     subtext="BoxHeader subtext"
 *     title="BoxHeader title"
 *   />
 *   <BoxBody>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </BoxBody>
 * </Box>
 * ```
 */

class BoxHeader extends React.Component<Props> {
  render() {
    const { action, dark, size, ...props } = this.props; // eslint-disable-line

    return (
      <TitleHeader
        {...props}
        action={action}
        actionPlacement={action ? 'right-center' : null}
        flush
        className={cx('BoxHeader', dark && 'BoxHeader--dark', size && `BoxHeader--${size}`)}
      />
    );
  }
}

export default BoxHeader;
